import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight as ArrowUpRight, FiMenu as Menu, FiX as Close } from "react-icons/fi";
import "./BrandPageShell.css";

const navigation = [
  { label: "About", href: "/about" },
  { label: "Markets", href: "/exchange" },
  { label: "Proof of reserve", href: "/proof-of-reserve" },
];

function BrandMark() {
  return (
    <span className="brand-lockup">
      <span className="brand-mark" aria-hidden="true">
        <svg viewBox="0 0 32 32" fill="none">
          <path d="m6 22 7-7 5 4 8-10" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M20 9h6v6" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
      <span className="brand-name">Profit<span>Growing</span></span>
    </span>
  );
}

export default function BrandPageShell({ children, active, pageClassName = "" }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <main className={"brand-page " + pageClassName}>
      <header className="brand-site-header">
        <div className="brand-container brand-header-row">
          <Link to="/" className="brand-home" aria-label="ProfitGrowing home" onClick={closeMenu}><BrandMark /></Link>
          <nav className={"brand-nav" + (menuOpen ? " is-open" : "")} aria-label="Main navigation">
            {navigation.map((item) => (
              <Link key={item.href} to={item.href} className={active === item.href ? "is-active" : ""} aria-current={active === item.href ? "page" : undefined} onClick={closeMenu}>{item.label}</Link>
            ))}
            <div className="brand-mobile-account">
              <Link to="/auth/login" onClick={closeMenu}>Log in</Link>
              <Link className="brand-nav-cta" to="/auth/register" onClick={closeMenu}>Create account</Link>
            </div>
          </nav>
          <div className="brand-header-actions">
            <Link to="/auth/login">Log in</Link>
            <Link className="brand-nav-cta" to="/auth/register">Create account <ArrowUpRight size={14} /></Link>
          </div>
          <button className="brand-menu-toggle" type="button" aria-label={menuOpen ? "Close menu" : "Open menu"} aria-expanded={menuOpen} onClick={() => setMenuOpen((open) => !open)}>
            {menuOpen ? <Close size={19} /> : <Menu size={19} />}
          </button>
        </div>
      </header>
      {children}
      <footer className="brand-footer">
        <div className="brand-container brand-footer-grid">
          <Link to="/" className="brand-home"><BrandMark /></Link>
          <p>Digital-asset information and account tools. Explore at your own pace.</p>
          <nav aria-label="Footer navigation">
            <Link to="/about">About</Link>
            <Link to="/exchange">Markets</Link>
            <Link to="/proof-of-reserve">Proof of reserve</Link>
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
          </nav>
          <small>Digital assets involve risk. Values can change quickly.</small>
        </div>
      </footer>
    </main>
  );
}
